/* tslint:disable */

import * as Sentry from 'utils/sentryLazy';
import { print } from 'graphql';
import get from 'lodash/get';
import { v4 as uuidv4 } from 'uuid';
import { call, put } from 'redux-saga/effects';
import 'whatwg-fetch';
import packageJson from '../../../package.json';
import {
  addStroreDisabled,
  allUoms,
  baseUoms,
  brand,
  brandWithCategories,
  brands,
  bulkReorder as bulkReorderMutation,
  buyer,
  buyerCreateAccount,
  buyerWebVersion,
  calculateVoucherDiscount,
  cart,
  cartClearSupplier,
  cartClearSupplierLight,
  cartCreateOrderDraft,
  cartDeleteDeliveryNote,
  cartDeleteItem,
  cartDeleteItemLight,
  cartGetAvailableDeliveryTimeSlots,
  cartGetDeliveryDateOffs,
  cartGetNextDeliveryDate,
  cartGetOrderDeadline,
  cartPutDeliveryDate,
  cartPutDeliveryNote,
  cartPutDeliveryTime,
  cartPutItem,
  cartPutItemLight,
  categories,
  categoryDescription,
  checkEmail,
  checkStoreIsDuplicate,
  companyInviteUsers,
  companyUpdate,
  createNewProductRequest,
  deletePendingOrder,
  deliveryNoteCreate,
  deliveryNoteDelete,
  deliveryNoteUpdate,
  deliveryNotes,
  districtSearch,
  favoriteAddItem,
  favoriteRemoveItem,
  featureFlagToggle,
  filterBrandsRelatedToCategory,
  filterCategoriesRelatedToBrand,
  sortBrandsBySKURelatedToCategory,
  fulfillmentNote,
  getAllOrigins,
  getAvailableVouchers,
  getDeliveryFee as getDeliveryFeeQuery,
  getFrequentlyBuyerTogether,
  getGroupCategories,
  getProductTags,
  getVaAndQrInfo,
  group,
  groupMemberAdd,
  groupMemberRemove,
  groupRTEByCity,
  groupRemove,
  invitation,
  invitationAccept,
  invitationAcceptAsNewBuyer,
  invitationSetStores,
  listHolidays,
  listSalesPic,
  me,
  meForgetPassword,
  meLogin,
  meRelogin,
  meResetPassword,
  meUpdate,
  meUpdateLang,
  meUpdatePassword,
  netUoms,
  notificationMarkAsReadMutation,
  notificationMessages,
  notificationRegisterMutation,
  notificationUnregisterMutation,
  order,
  orderApprove,
  orderCancel,
  orderCreate,
  orderDecline,
  orderDraft,
  orderReceive,
  orderReorder,
  orderStatistics,
  orderTotalSummary,
  orderUpdateDeliveredItems,
  orderUpdateItem,
  orderUpdateUnitPrice,
  orders,
  ordersExport,
  printOrderInvoice,
  product,
  productSearch,
  homeProductSearch,
  productSetNote,
  provinceSearch,
  putItemsToFavorite,
  rteLocationList,
  storeCreate,
  storeOrderItemsSummary,
  storeUpdate,
  submitFeedback as submitFeedbackMutation,
  updatePendingOrder,
  user,
  userGroupCreate,
  userGroupUpdate,
  userRemove,
  userUpdate,
  users,
  wardSearch,
  widgets,
  pingUser,
  writeContactUsInfo,
  getItemsInSameProductGroups,
  getBrandItemsInSameProductGroups,
  saveSearchHistory,
  getSearchHistory,
  deleteSearchHistory,
  checkIsBadWord,
  getTrendingSearchForGuestUser,
  getRecommendSkuForSigninUser,
  submitKeepInTouchForm,
  getItemsInSameProductFamily,
  getVouchersForProduct,
  getProductFeedbacks,
  countFeedbackRating,
  getUnreviewedOrderItems,
  feedbackProduct,
  fetchExternalRedInvoice,
  searchNewWardForStore,
  updateStoreBasicInfo,
  cartPutInvoiceNote,
  downloadDeliveryNote,
  setDraftOrderDeliveryDateTime,
  setDraftOrderDeliveryNote,
  checkAndMergeGuestCart,
  getListTeamByFilter,
  widgetsV2,
} from '../query';
const { version } = packageJson;

import { ApolloClient, HttpLink, split } from '@apollo/client';
import { BatchHttpLink } from '@apollo/client/link/batch-http';
import { ApolloCache, InMemoryCache, NormalizedCacheObject } from '@apollo/client/cache';
import { setContext } from '@apollo/client/link/context';
import { signout } from 'containers/MainLayout/actions';
import jwtDecode from 'jwt-decode';
import {
  AvailableVouchersForStoreInput,
  MutationCartPutItemLightsArgs,
  MutationSubmitFeedbackArgs,
  QueryBrandsArgs,
  QueryBrandsForHomeArgs,
  QueryCategoryDetailArgs,
  QueryDistrictSearchArgs,
  QueryFilterBrandsRelatedToCategoryArgs,
  QueryFilterCategoriesRelatedToBrandArgs,
  QueryFindFullAddressArgs,
  QueryGetGroupCategoriesArgs,
  QueryGetRteLocationListArgs,
  QueryListSalesPicArgs,
  QueryNotificationMessagesArgs,
  QueryOrdersOrFulfillmentNotesArgs,
  QueryProductSearchArgs,
  QueryProvinceSearchArgs,
  QuerySortBrandsBySkuRelatedToCategoryArgs,
  QueryWardSearchArgs,
} from 'types/schema';
import orderDisabled from 'utils/query/orderDisabled';
import productBySupplierInternalCode from 'utils/query/productBySupplierInternalCode';
import recommendationItems from 'utils/query/recommendationItems';
import sendContactUs from 'utils/query/sendContactUs';
import { clearToken, setToken } from 'utils/preloadHintCookie';
import { createLoggerWithSentry } from '../../logger';
import findFullAddress from '../query/findFullAddress';
import ordersOrFulfillmentNotes from '../query/ordersOrFulfillmentNotes';

const apiUrl = process.env.API_URL || 'https://buyer-graphql.qa.kamereo.vn';

const apolloLogger = createLoggerWithSentry({
  defaultScope: {
    component: 'Apollo',
    source: 'apollo-client',
  },
  enableBreadcrumbs: true,
  enableTracing: true,
});

const NODE_API_URL = '/api/v1';

type Option = {
  headers: HeadersInit;
  method?: string;
  body?: any;
};

// eslint-disable-next-line import/no-mutable-exports
let headers: HeadersInit;

const defaultOptions: any = {
  watchQuery: {
    fetchPolicy: 'network-only',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'network-only',
    errorPolicy: 'ignore',
  },
};

async function refreshToken() {
  const rememberToken = window.localStorage.getItem('rememberToken');
  const response = await fetch(apiUrl, {
    method: 'POST',
    body: JSON.stringify({
      operationName: 'meRelogin',
      variables: { token: rememberToken },
      query: print(meRelogin),
    }),
    headers: {
      accept: '*/*',
      'content-type': 'application/json',
      'X-Client-AppName': 'BuyerWeb',
      'X-Client-Version': version,
    },
  });
  const data = await response.json();
  return data;
}

async function handleTokenExpiry(requestToken: string) {
  const decodedToken = jwtDecode(requestToken);

  if (Date.now() > decodedToken.exp * 1000) {
    const data = await refreshToken();
    const error = (data.errors || []).find((error) =>
      (error.graphQLErrors || []).find(
        (error) => error.extensions.subcode === '6101' || error.extensions.subcode === '6102',
      ),
    );

    if (error) {
      clearToken();
      window.localStorage.removeItem('rememberToken');
    }

    const reoginToken = get(data, ['data', 'meRelogin', 'token']);

    if (reoginToken) {
      setToken(reoginToken);
      if (data.data.meRelogin.rememberMeToken) {
        window.localStorage.setItem('rememberToken', data.data.meRelogin.rememberMeToken);
      }

      requestToken = reoginToken;
    }
  }

  return requestToken;
}

// Chọn URL e1-e6 một lần cho cả session (load-balance phía client). Trước đây
// random mỗi request, nhưng để gộp batch thì mọi operation phải đi chung 1 link
let sharedApiUrl: string | undefined;
function getApiUrl(): string {
  if (sharedApiUrl) return sharedApiUrl;
  let newApiUrl = apiUrl;
  const random = Math.floor(Math.random() * 6) + 1;
  if (random !== 1) {
    newApiUrl = apiUrl.replace('buyer-graphql', `e${random}-buyer-graphql`);
  }
  sharedApiUrl = newApiUrl;
  return sharedApiUrl;
}

// Delivery slot là giờ nghiệp vụ VN cố định (SHO-3127). Các operation dưới đây được BE
// render khung giờ giao / giờ nghiệp vụ theo header X-Timezone, nên phải ép về giờ VN
// thay vì timezone thiết bị khách. Chỉ scope đúng các API cần thiết, không đụng global.
const DELIVERY_TIMEZONE = 'Asia/Ho_Chi_Minh';
const DELIVERY_TZ_OPERATIONS = new Set<string>([
  'order', // chi tiết đơn (deliveryTime)
  'orders', // danh sách đơn
  'ordersOrFulfillmentNotes', // danh sách đơn / phiếu giao
  'ordersExport', // export đơn (giờ giao + ngày đặt)
  'fulfillmentNote', // chi tiết phiếu giao
  'cart', // giỏ hàng (deliveryTimeSlots / deliveryDatetime)
  'cartGetNextDeliveryDate', // ngày giao kế tiếp cho date-picker
  'cartGetAvailableDeliveryTimeSlots', // khung giờ khả dụng cho date-picker (BE hiện tz-independent, thêm để nhất quán)
  'cartGetDeliveryDateOffs', // ngày off cho date-picker (BE hiện tz-independent, thêm để nhất quán)
]);

// Client singleton
let sharedClient: ApolloClient<NormalizedCacheObject> | undefined;
function getApolloClient(): ApolloClient<NormalizedCacheObject> {
  if (sharedClient) return sharedClient;

  const batchLink = new BatchHttpLink({
    uri: getApiUrl(),
    batchMax: 10,
    batchInterval: 20,
  });

  // Batch trả về theo operation CHẬM NHẤT trong batch. Operation găng cho first
  // paint (widgetsRedesign nuôi TOP_BANNER/LCP, productSearch BEST_DEALS) đặt
  // context.noBatch để đi kênh riêng, không chờ cart/OrderStatistics...
  const noBatchLink = new HttpLink({ uri: getApiUrl() });
  const transportLink = split((operation) => operation.getContext().noBatch === true, noBatchLink, batchLink);

  // Tính header (token, store, lang...) theo từng operation để luôn dùng token
  // mới nhất; operation cùng header sẽ được gộp chung 1 batch.
  const authLink = setContext(async (operation: any, { headers: existingHeaders, isRequiredToken }: any) => {
    // BE (BuyerGraphQL) diễn giải delivery slot / giờ nghiệp vụ theo header X-Timezone.
    // Với các operation trả về khung giờ giao, ép X-Timezone = giờ VN để không lệch theo
    // timezone thiết bị khách (SHO-3127). Header khác nhau => BatchHttpLink tự tách batch riêng.
    const headersWithTz = DELIVERY_TZ_OPERATIONS.has(operation?.operationName)
      ? { ...existingHeaders, 'X-Timezone': DELIVERY_TIMEZONE }
      : existingHeaders;
    const freshHeaders = await getHeaders(headersWithTz, isRequiredToken);
    return {
      headers: freshHeaders,
    };
  });

  sharedClient = new ApolloClient({
    link: authLink.concat(transportLink),
    cache: new InMemoryCache({
      typePolicies: {
        Category: {
          // Same category id can appear under multiple parents. Default normalization by id
          // merges them and overwrites nameLocal. Embed instead so nav children stay distinct.
          keyFields: false,
        },
      },
    }) as ApolloCache<NormalizedCacheObject>,
    defaultOptions: defaultOptions,
  });

  return sharedClient;
}

function scheduleToRevalidate(client: ApolloClient<NormalizedCacheObject>, options: any) {
  const duration = options.duration || 600000; // 10 minutes in milliseconds
  const intervalId = setInterval(() => {
    client
      .query({ query: options.query, variables: options.variables })
      .then((response: any) => {
        const newData = options.transform ? options.transform(response.data) : response.data;
        client.writeQuery({
          query: options.query,
          data: {
            [options.query.definitions[0].name.value]: newData,
          },
        });
      })
      .catch((error) => {
        if (process.env.APP_ENV !== 'development') {
          apolloLogger.error(error, {
            ...options,
            action: 'scheduleToRevalidate',
            url: window.location.href,
            userAgent: navigator.userAgent,
            timestamp: new Date().toISOString(),
          });
        }
      });
  }, duration);

  // Cleanup function to clear the interval
  window.addEventListener('beforeunload', () => clearInterval(intervalId));
}

function writeToCache(client: ApolloClient<NormalizedCacheObject>, options: any) {
  const data = options.transform ? options.transform(options.data) : options.data;
  try {
    client.writeQuery({
      query: options.query,
      data: {
        [options.query.definitions[0].name.value]: data,
      },
    });
  } catch (error) {
    if (process.env.APP_ENV !== 'development') {
      apolloLogger.error(error, {
        ...options,
        action: 'writeToCache',
        url: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      });
    }

    return {
      errors: [error],
    };
  }
  if (options.revalidation) {
    scheduleToRevalidate(client, options);
  }
  return { success: true };
}

export async function getHeaders(existingHeaders: HeadersInit = {}, isRequiredToken = true) {
  const { authorization, Authorization, ...existingHeadersWithoutToken } = existingHeaders as Record<string, string>;
  let requestToken = isRequiredToken ? localStorage.getItem('token') : undefined;
  let region = localStorage.getItem('region') || 'HCM';
  let anonymousId = localStorage.getItem('anonymousId');

  if (!anonymousId) {
    anonymousId = uuidv4();
    localStorage.setItem('anonymousId', anonymousId);
  }

  if (requestToken) {
    requestToken = await handleTokenExpiry(requestToken);
  }

  return {
    ...existingHeadersWithoutToken,
    ...(isRequiredToken ? { authorization: requestToken ? `Bearer ${requestToken}` : '' } : {}),
    'X-Store': window.localStorage.getItem('store') || '',
    'Accept-Language': window.localStorage.getItem('lang') ?? 'vi',
    'X-Timezone':
      (existingHeaders as Record<string, string>)['X-Timezone'] ||
      Intl.DateTimeFormat().resolvedOptions().timeZone ||
      'Asia/Ho_Chi_Minh',
    'X-Client-AppName': 'BuyerWeb',
    'X-Client-Version': version,
    'X-CustomHeader': region,
    'X-AnonymousId': anonymousId,
  };
}

(async () => {
  headers = await getHeaders();
})();

export { headers };

export const request = function* (options: any, authentication = true) {
  const loggedIn = !!window.localStorage.getItem('token');
  const isRequiredToken = options?.isRequiredToken !== false;
  const operationOptions = {
    ...options,
    context: {
      ...options.context,
      isRequiredToken,
    },
  };
  delete operationOptions.isRequiredToken;

  const client = getApolloClient();

  if (authentication && !loggedIn) {
    yield put(signout());
    return yield Promise.reject({ errors: [{ message: 'Authentication is required' }] });
  }

  function checkTypename(variables) {
    if (Array.isArray(variables)) {
      return variables.map((v) => checkTypename(v));
    }

    if (!variables || typeof variables !== 'object') {
      return variables;
    }

    if ('__typename' in variables) {
      const { __typename, ...withoutTypename } = variables;
      return checkTypename(withoutTypename);
    }

    for (const key in variables) {
      if (typeof variables[key] === 'object') {
        variables[key] = checkTypename(variables[key]);
      }
    }

    return variables;
  }

  if (options.variables && typeof options.variables === 'object') {
    checkTypename(options.variables);
  }
  if (options.mutation) {
    return yield client
      .mutate({ ...operationOptions, errorPolicy: 'all' })
      .then((response: any) => {
        if (options.mutation.definitions.length === 1) {
          if (response.data) {
            if (options.transform) {
              return options.transform(response.data);
            }
            const data = response.data[options.mutation.definitions[0].name.value];
            if (data) {
              if (data.success !== false) {
                return data;
              }
              return { errors: data.userErrors };
            }
          }
          return { errors: response.errors || [{ message: 'Something wrong' }] };
        }
        return options.transform ? options.transform(response.data) : response.data;
      })
      .catch((error) => {
        if (process.env.APP_ENV !== 'development') {
          Sentry.withScope((scope) => {
            Object.keys(options).forEach((key) => {
              scope.setExtra(key, options[key]);
            });

            captureException(error, options);
          });
        }

        return {
          errors: [error],
        };
      });
  }
  if (options?.preload && options?.data) {
    writeToCache(client, options);
  }

  return yield client
    .query(
      operationOptions.errorPolicy
        ? { ...operationOptions, errorPolicy: operationOptions.errorPolicy }
        : operationOptions,
    )
    .then((response: any) => {
      if (options.query.definitions.length === 1) {
        if (response.data) {
          if (options.transform) {
            return options.transform(response.data);
          }
          const data = response.data[options.query.definitions[0].name.value];
          if (data) {
            return data;
          }
        }
        return { errors: response.errors?.length ? response.errors : [{ message: 'Something wrong' }] };
      }
      return options.transform ? options.transform(response.data) : response.data;
    })
    .catch((error) => {
      if (process.env.APP_ENV !== 'development') {
        Sentry.withScope((scope) => {
          Object.keys(options).forEach((key) => {
            scope.setExtra(key, options[key]);
          });

          captureException(error, options);
        });
      }

      return {
        errors: [error],
      };
    });
};

function captureException(error, options) {
  const { mutation, query, variables } = options;
  const { name } = (mutation && mutation.definitions[0]) || (query && query.definitions[0]);
  const additionalInfo = JSON.stringify({
    name,
    variables,
  });

  // sending additional information to Sentry via breadcrumb
  // as sending via captureException truncates the data
  Sentry.addBreadcrumb({
    category: 'exception',
    message: additionalInfo,
    level: Sentry.Severity.Debug,
  });

  Sentry.captureException(new Error(`Error: ${JSON.stringify(error)}`));
}

export function* fetchApi(endpoint: string, options: Option) {
  return yield call(fetch, `${NODE_API_URL}/${endpoint}/${window.localStorage.getItem('lang') || 'vi'}`, {
    method: options?.method || 'GET',
    headers: {
      ...options.headers,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(options?.body),
  });
}

export function* contactUs(variables: any) {
  return yield call(request, { variables: variables, mutation: sendContactUs }, false);
}

export function* signin(variables: any) {
  return yield call(request, { variables: variables, mutation: meLogin }, false);
}

export function* signup(variables: any) {
  return yield call(request, { variables: variables, mutation: buyerCreateAccount, isRequiredToken: false }, false);
}

export function* forgetPassword(variables: any) {
  return yield call(request, { variables: variables, mutation: meForgetPassword }, false);
}

export function* resetPassword(variables: any) {
  return yield call(request, { variables: variables, mutation: meResetPassword }, false);
}

export function* checkValidEmail(variables: any) {
  return yield call(request, { variables: variables, mutation: checkEmail, isRequiredToken: false }, false);
}

export function* sendRequest(options) {
  return yield call(request, options);
}

export function* updatePassword(variables: any) {
  return yield call(request, { variables: variables, mutation: meUpdatePassword });
}

export function* updateProfile(variables: any) {
  return yield call(request, { variables: variables, mutation: meUpdate });
}

export function* updateLang(variables: any) {
  return yield call(request, { variables: variables, mutation: meUpdateLang });
}

export function* updateUser(variables: any) {
  return yield call(request, { variables: variables, mutation: userUpdate });
}

export function* deleteUser(variables: any) {
  return yield call(request, { variables: variables, mutation: userRemove });
}

export function* getCart(variables: any) {
  return yield call(request, { variables: variables, query: cart }, false);
}

export function* getUser() {
  return yield call(request, { query: me });
}

export function* inviteBuyerUsers(variables: any) {
  return yield call(request, { variables: variables, mutation: companyInviteUsers });
}

export function* getUsers() {
  return yield call(request, { query: users });
}

export function* removeUser(variables: any) {
  return yield call(request, { variables, mutation: removeUser });
}

export function* getCompanyUser(variables: any) {
  return yield call(request, { variables: variables, query: user });
}

export function* getBuyer() {
  return yield call(request, { query: buyer });
}

export function* getCategories(variables?: any) {
  return yield call(request, { variables: variables, query: categories, preload: true }, false);
}

export function* preloadCategoriesAndRevalidate(variables?: any) {
  const preloadCategories = (window as any).__PRELOADED_STATE__?.categories;
  if (preloadCategories) {
    const response = yield call(
      request,
      { variables: variables, query: categories, preload: true, data: preloadCategories, revalidation: false },
      false,
    );
    if (response.success) {
      return preloadCategories;
    }
    return yield call(request, { variables: variables, query: categories }, false);
  }
  return yield call(request, { variables: variables, query: categories }, false);
}

export function* addFavorite(variables: any) {
  return yield call(request, { variables: variables, mutation: favoriteAddItem });
}

export function* removeFavorite(variables: any) {
  return yield call(request, { variables: variables, mutation: favoriteRemoveItem });
}

export function* addCartItem(variables: any) {
  return yield call(request, { variables: variables, mutation: cartPutItem });
}

export function* addCartItemLight(variables: any) {
  return yield call(request, { variables: variables, mutation: cartPutItemLight }, false);
}

export function* addCartItemLights(variables: MutationCartPutItemLightsArgs) {
  return yield call(request, { variables: variables, mutation: addCartItemLights });
}

export function* removeCartItem(variables: any) {
  return yield call(request, { variables: variables, mutation: cartDeleteItem });
}

export function* removeCartItemLight(variables: any) {
  return yield call(request, { variables: variables, mutation: cartDeleteItemLight }, false);
}

export function* updateCartDeliveryDate(variables: any) {
  return yield call(request, { variables: variables, mutation: cartPutDeliveryDate });
}

export function* updateCartDeliveryTime(variables: any) {
  return yield call(request, { variables: variables, mutation: cartPutDeliveryTime });
}

export function* addCartDeliveryNote(variables: any) {
  return yield call(request, { variables: variables, mutation: cartPutDeliveryNote });
}

export function* removeCartSupplier(variables: any) {
  return yield call(request, { variables: variables, mutation: cartClearSupplier });
}

export function* removeCartSupplierLight(variables: any) {
  return yield call(request, { variables: variables, mutation: cartClearSupplierLight }, false);
}

export function* removeCartDeliveryNote(variables: any) {
  return yield call(request, { variables: variables, mutation: cartDeleteDeliveryNote });
}

export function* createOrderDraft(variables: any) {
  return yield call(request, { variables: variables, mutation: cartCreateOrderDraft });
}

export function* getOrderDraft(variables: any) {
  return yield call(request, { variables: variables, query: orderDraft });
}

export function* createOrder(variables: any) {
  return yield call(request, { variables: variables, mutation: orderCreate });
}

export function* getDeliveryNotes() {
  return yield call(request, { query: deliveryNotes });
}

export function* createDeliveryNote(variables: any) {
  return yield call(request, { variables: variables, mutation: deliveryNoteCreate });
}

export function* updateDeliveryNote(variables: any) {
  return yield call(request, { variables: variables, mutation: deliveryNoteUpdate });
}

export function* removeDeliveryNote(variables: any) {
  return yield call(request, { variables: variables, mutation: deliveryNoteDelete });
}

export function* addStore(variables: any) {
  return yield call(request, { variables: variables, mutation: storeCreate });
}

export function* updateStore(variables: any) {
  return yield call(request, { variables: variables, mutation: storeUpdate });
}

// productSearch rút gọn field cho section trang chủ - xem chú thích trong
// utils/query/homeProductSearch.ts
export function* getHomeProducts(variables: QueryProductSearchArgs, noBatch = false) {
  const regionCode = window.localStorage.getItem('region') || 'HCM';

  return yield call(
    request,
    {
      variables: {
        ...variables,
        filter: {
          ...variables.filter,
          regionCode,
        },
      },
      query: homeProductSearch,
      transform: (data: any) => data?.productSearch ?? { errors: [{ message: 'Empty productSearch response' }] },
      ...(noBatch ? { context: { noBatch: true } } : {}),
    },
    false,
  );
}

export function* getProducts(variables: QueryProductSearchArgs, noBatch = false) {
  const regionCode = window.localStorage.getItem('region') || 'HCM';

  return yield call(
    request,
    {
      variables: {
        ...variables,
        filter: {
          ...variables.filter,
          regionCode,
        },
      },
      query: productSearch,
      ...(noBatch ? { context: { noBatch: true } } : {}),
    },
    false,
  );
}

export function* getDescriptionById(variables: QueryCategoryDetailArgs) {
  return yield call(request, { variables: variables, query: categoryDescription }, false);
}

export function* getProduct(variables: any) {
  const regionCode = window.localStorage.getItem('region') || 'HCM';
  return yield call(
    request,
    {
      variables: {
        ...variables,
        regionCode,
      },
      query: product,
    },
    false,
  );
}
export function* getProductBySupplierInternalCode(variables: { supplierInternalCode: string }) {
  return yield call(request, { variables: variables, query: productBySupplierInternalCode }, false);
}

export function* getRecommendationItems(variables: any) {
  return yield call(request, { variables, query: recommendationItems });
}

export function* getStoreOrderItemsSummary(variables: any) {
  return yield call(request, { variables: variables, query: storeOrderItemsSummary });
}

export function* getOrder(variables: any) {
  return yield call(request, { variables: variables, query: order });
}

export function* getFulfillmentNote(variables: any) {
  return yield call(request, { variables: variables, query: fulfillmentNote });
}

export function* getOrders(variables: any) {
  return yield call(request, { variables: variables, query: orders });
}

export function* getOrdersOrFulfillmentNotes(variables: QueryOrdersOrFulfillmentNotesArgs) {
  return yield call(request, { variables: variables, query: ordersOrFulfillmentNotes });
}

export function* downloadOrdersReport(variables: any) {
  return yield call(request, { variables: variables, query: ordersExport });
}

export function* createReOrder(variables: any) {
  return yield call(request, { variables: variables, mutation: orderReorder });
}

export function* bulkReorder(variables: any) {
  return yield call(request, { variables: variables, mutation: bulkReorderMutation });
}

export function* updateDeliveryItem(variables: any) {
  return yield call(request, { variables: variables, mutation: orderUpdateDeliveredItems });
}

export function* updateOrderItem(variables: any) {
  return yield call(request, { variables: variables, mutation: orderUpdateItem });
}

export function* updateUnitPrice(variables: any) {
  return yield call(request, { variables: variables, mutation: orderUpdateUnitPrice });
}

export function* confirmOrder(variables: any) {
  return yield call(request, { variables: variables, mutation: orderReceive });
}

export function* updateOrderStatusToCancel(variables: any) {
  return yield call(request, { variables: variables, mutation: orderCancel });
}

export function* updateCompany(variables: any) {
  return yield call(request, {
    variables: variables,
    mutation: companyUpdate,
    transform: (data: any) => {
      const buyer = data['buyerUpdate'];
      const redInvoice = data['companyUpdateRedInvoice'];
      let result: any = {};
      if (!buyer.success && !redInvoice.success) {
        result.errors = [].concat(buyer.userErrors || [], redInvoice.userErrors || []);
      }
      if (buyer.success) {
        result = { ...buyer };
      }
      if (redInvoice.success) {
        result.redInvoiceInfo = { ...redInvoice };
      }

      return result;
    },
  });
}

export function* getOrderStatistics(variables: any) {
  return yield call(request, {
    variables: variables,
    query: orderStatistics,
    transform: (data: any) => {
      return data;
    },
  });
}

export function* getOrderTotalSummary(variables: any) {
  return yield call(request, { variables: variables, query: orderTotalSummary });
}

export function* getAvailableDeliveryTimeSlots(variables: any) {
  return yield call(request, { variables: variables, query: cartGetAvailableDeliveryTimeSlots });
}

export function* getDeliveryDateOffs(variables: any) {
  return yield call(request, { variables: variables, query: cartGetDeliveryDateOffs });
}

export function* getNextDeliveryDate(variables: any) {
  return yield call(request, { variables: variables, query: cartGetNextDeliveryDate });
}

export function* getOrderDeadline(variables: any) {
  return yield call(request, { variables: variables, query: cartGetOrderDeadline });
}

export function* getGroup(variables: any) {
  return yield call(request, { variables, query: group });
}

export function* createGroup(variables: any) {
  return yield call(request, { variables, mutation: userGroupCreate });
}

export function* updateGroup(variables: any) {
  return yield call(request, { variables, mutation: userGroupUpdate });
}

export function* addMembersGroup(variables: any) {
  return yield call(request, { variables, mutation: groupMemberAdd });
}

export function* removeMembersGroup(variables: any) {
  return yield call(request, { variables, mutation: groupMemberRemove });
}

export function* deleteGroup(variables: any) {
  return yield call(request, { variables, mutation: groupRemove });
}

export function* setFeatureFlag(variables: any) {
  return yield call(request, { variables, mutation: featureFlagToggle });
}

export function* approveOrder(variables: any) {
  return yield call(request, { variables, mutation: orderApprove });
}

export function* declineOrder(variables: any) {
  return yield call(request, { variables, mutation: orderDecline });
}

export function* updateOrderPending(variables: any) {
  return yield call(request, { variables, mutation: updatePendingOrder });
}

export function* deleteOrderPending(variables: any) {
  return yield call(request, { variables, mutation: deletePendingOrder });
}

export function* setProductNote(variables: any) {
  return yield call(request, { variables, mutation: productSetNote });
}

export function* getInvitation(variables: any) {
  return yield call(request, { variables, query: invitation }, false);
}

export function* acceptInvitation(variables: any) {
  return yield call(request, { variables, mutation: invitationAccept }, false);
}

export function* acceptAsNewBuyerInvitation(variables: any) {
  return yield call(request, { variables, mutation: invitationAcceptAsNewBuyer }, false);
}

export function* setInvitationStores(variables: any) {
  return yield call(request, { variables, mutation: invitationSetStores }, false);
}

export function* getOrderDisabled() {
  return yield call(request, { query: orderDisabled });
}

export function* notificationTokenRegister(variables: any) {
  return yield call(request, { variables, mutation: notificationRegisterMutation });
}

export function* notificationTokenUnregister(variables: any) {
  return yield call(request, { variables, mutation: notificationUnregisterMutation });
}

export function* notificationMarkAsRead(variables: any) {
  return yield call(request, { variables, mutation: notificationMarkAsReadMutation });
}

export function* getWidgetConfig(variables: any) {
  return yield call(request, { variables: variables, query: widgets }, false);
}

export function* getWidgetConfigV2(variables: any) {
  return yield call(request, { variables: variables, query: widgetsV2, context: { noBatch: true } }, false);
}

export function* getNotificationMessages(variables: QueryNotificationMessagesArgs) {
  return yield call(request, { variables, query: notificationMessages });
}

export function* getAddStoreDisabled() {
  return yield call(request, { query: addStroreDisabled });
}

export function* getBuyerWebVersion() {
  return yield call(request, { query: buyerWebVersion }, false);
}

export function* getBrand(variables: any) {
  return yield call(request, { variables: variables, query: brand }, false);
}

export function* getBrands(variables: QueryBrandsArgs) {
  return yield call(request, { variables: variables, query: brands }, false);
}

export function* getBrandsWithCategories(variables: QueryBrandsForHomeArgs) {
  return yield call(request, { variables: variables, query: brandWithCategories }, false);
}
export function* getBrandsRelatedToCategory(variables: QueryFilterBrandsRelatedToCategoryArgs) {
  return yield call(request, { variables: variables, query: filterBrandsRelatedToCategory }, false);
}
export function* getSortBrandsBySKURelatedToCategory(variables: QuerySortBrandsBySkuRelatedToCategoryArgs) {
  return yield call(request, { variables: variables, query: sortBrandsBySKURelatedToCategory }, false);
}
export function* getProvince(variables: QueryProvinceSearchArgs) {
  return yield call(request, { variables: variables, query: provinceSearch, isRequiredToken: false }, false);
}

export function* getDistricts(variables: QueryDistrictSearchArgs) {
  return yield call(request, { variables: variables, query: districtSearch, isRequiredToken: false }, false);
}

export function* getWards(variables: QueryWardSearchArgs) {
  return yield call(request, { variables: variables, query: wardSearch, isRequiredToken: false }, false);
}

export function* getFullAddress(variables: QueryFindFullAddressArgs) {
  return yield call(request, { variables: variables, query: findFullAddress }, false);
}

export function* getListSalesPic(variables: QueryListSalesPicArgs) {
  return yield call(request, { variables: variables, query: listSalesPic, isRequiredToken: false }, false);
}

export function* getGroupCategoriesData(variables: QueryGetGroupCategoriesArgs) {
  return yield call(request, { variables: variables, query: getGroupCategories }, false);
}

export function* getCategoriesRelatedToBrand(variables: QueryFilterCategoriesRelatedToBrandArgs) {
  return yield call(request, { variables: variables, query: filterCategoriesRelatedToBrand }, false);
}

export function* getGroupRTEByCity() {
  return yield call(request, { query: groupRTEByCity }, false);
}

export function* getRTELocationList(variables: QueryGetRteLocationListArgs) {
  return yield call(request, { variables: variables, query: rteLocationList }, false);
}

export function* requestNewProductItem(variables: any) {
  return yield call(request, { variables: variables, mutation: createNewProductRequest }, false);
}

export function* getVaAndQrInfoData(variables: any) {
  return yield call(request, { variables: variables, query: getVaAndQrInfo });
}

export function* getAllUoms() {
  return yield call(request, { query: allUoms }, false);
}

export function* getOrigins() {
  return yield call(request, { query: getAllOrigins }, false);
}

export function* handleCheckStoreIsDuplicate(variables) {
  return yield call(request, { variables: variables, mutation: checkStoreIsDuplicate }, false);
}

export function* getDeliveryFee(variables: any) {
  return yield call(request, { variables: variables, query: getDeliveryFeeQuery });
}

export function* getOrderInvoice(variables: any) {
  return yield call(request, {
    variables: variables,
    query: printOrderInvoice,
    transform: (data: any) => {
      return data;
    },
  });
}

export function* getVouchers(variables: AvailableVouchersForStoreInput) {
  return yield call(request, { variables: variables, query: getAvailableVouchers });
}

export function* calculateVoucher(variables: any) {
  return yield call(request, { variables: variables, mutation: calculateVoucherDiscount });
}
export function* handlePutItemsToFavorite(variables) {
  return yield call(request, { variables, mutation: putItemsToFavorite });
}

export function* getListHolidays() {
  return yield call(request, { query: listHolidays });
}

export function* handleGetFrequentlyBuyTogether(variables) {
  return yield call(request, { variables, query: getFrequentlyBuyerTogether });
}

export function* getProductTagList() {
  return yield call(request, { query: getProductTags }, false);
}

export function* handleWriteContactUsInfo(variables) {
  return yield call(request, { variables: variables, mutation: writeContactUsInfo }, false);
}

export function* getBaseUoms() {
  return yield call(request, { query: baseUoms }, false);
}

export function* getNetUoms() {
  return yield call(request, { query: netUoms }, false);
}

export function* submitFeedback(variables: { input: MutationSubmitFeedbackArgs['input'] }) {
  return yield call(request, { variables: variables, mutation: submitFeedbackMutation });
}

export function* handlePingUser(variables) {
  return yield call(request, { mutation: pingUser, variables }, false);
}

export function* getItemsInSameProductGroupsApi(variables) {
  return yield call(request, { query: getItemsInSameProductGroups, variables }, false);
}

export function* getBrandItemsInSameProductGroupsApi(variables) {
  return yield call(request, { query: getBrandItemsInSameProductGroups, variables }, false);
}

export function* fetchSearchHistory(variables) {
  return yield call(request, { query: getSearchHistory, variables });
}

export function* handleSaveSearchHistory(variables) {
  return yield call(request, { mutation: saveSearchHistory, variables });
}

export function* handleDeleteSearchHistory(variables) {
  return yield call(request, { mutation: deleteSearchHistory, variables });
}

export function* handleCheckBadWord(variables) {
  return yield call(request, { query: checkIsBadWord, variables }, false);
}

export function* fetchTrendingSearchForGuestUser() {
  return yield call(request, { query: getTrendingSearchForGuestUser }, false);
}

export function* fetchRecommendSkuForSigninUser() {
  return yield call(request, { query: getRecommendSkuForSigninUser });
}

export function* submitKeepInTouchFormApi(variables) {
  return yield call(request, { mutation: submitKeepInTouchForm, variables }, false);
}

export function* getItemsInSameProductFamilyApi(variables) {
  return yield call(request, { query: getItemsInSameProductFamily, variables }, false);
}

export function* getVouchersForProductApi(variables) {
  return yield call(request, { query: getVouchersForProduct, variables }, false);
}

export function* getProductFeedbacksApi(variables) {
  return yield call(request, { query: getProductFeedbacks, variables }, false);
}

export function* countFeedbackRatingApi(variables) {
  return yield call(request, { query: countFeedbackRating, variables }, false);
}

export function* getUnreviewedOrderItemsApi(variables) {
  return yield call(request, { query: getUnreviewedOrderItems, variables });
}

export function* feedbackProductApi(variables) {
  return yield call(request, { mutation: feedbackProduct, variables });
}

export function* fetchExternalRedInvoiceApi(variables) {
  return yield call(request, { query: fetchExternalRedInvoice, variables }, false);
}

export function* searchNewWardForStoreAddress(variables) {
  return yield call(request, { query: searchNewWardForStore, variables });
}

export function* updateStoreBasicInfoApi(variables) {
  return yield call(request, { mutation: updateStoreBasicInfo, variables });
}

export function* cartPutInvoiceNoteApi(variables: any) {
  return yield call(request, { variables: variables, mutation: cartPutInvoiceNote });
}

export function* downloadDeliveryNoteApi(variables) {
  return yield call(request, { variables, query: downloadDeliveryNote });
}

export function* setDraftOrderDeliveryDateTimeApi(variables) {
  return yield call(request, { variables, mutation: setDraftOrderDeliveryDateTime });
}

export function* setDraftOrderDeliveryNoteApi(variables) {
  return yield call(request, { variables, mutation: setDraftOrderDeliveryNote });
}

export function* checkAndMergeGuestCartApi(variables) {
  return yield call(request, { variables, mutation: checkAndMergeGuestCart });
}
export function* getListTeamByFilterApi(variables) {
  return yield call(request, { query: getListTeamByFilter, variables, isRequiredToken: false }, false);
}
